module.exports = __webpack_public_path__ + "static/media/assa-header-logo.dde83995.svg";